import { type TFunction } from 'i18next'
import { z } from 'zod'

export function getNameSchema(t: TFunction<'common'>, locale: string) {
  return (
    z
      .string({
        required_error: t('form.name.errors.required', { lng: locale }),
      })
      // eslint-disable-next-line no-useless-escape
      .regex(/[\p{L} '\-]+/u, {
        message: t('form.name.errors.invalid', { lng: locale }),
      })
  )
}

export function getEmailSchema(t: TFunction, locale: string) {
  return (
    z
      .string({
        required_error: t('form.email.errors.required', { lng: locale }),
      })
      .email({ message: t('form.email.errors.invalid', { lng: locale }) })
      // Make sure email is always lowercase
      .transform(value => value.toLowerCase())
  )
}

export function getPhoneSchema(t: TFunction, locale: string) {
  return z
    .string({
      required_error: t('form.phone.errors.required', { lng: locale }),
    })
    .regex(/^(\+\d{2,3}|0)\d{9}$/, {
      message: t('form.phone.errors.invalid', { lng: locale }),
    })
}

export function getMessageSchema(t: TFunction, locale: string) {
  return z
    .string({
      required_error: t('form.message.errors.required', { lng: locale }),
    })
    .min(10, { message: t('form.message.errors.length.min', { lng: locale }) })
}
